import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import AiToolbar from "@/components/admin/AiToolbar";

const PAGES = [
  { value: "home", label: "Homepage" },
  { value: "about", label: "About" },
  { value: "sectors", label: "Sectors" },
  { value: "ventures", label: "Joint Ventures" },
  { value: "leadership", label: "Leadership" },
  { value: "offices", label: "Offices" },
  { value: "news", label: "News & Insights" },
  { value: "contact", label: "Contact" },
];

export default function SeoListField({ label, value, onChange }) {
  const arr = Array.isArray(value) ? value : [];

  const patch = (i, part) => {
    const c = [...arr];
    c[i] = { ...(arr[i] || {}), ...part };
    onChange(c);
  };

  return (
    <div className="md:col-span-2">
      <div className="flex items-center justify-between">
        <div>
          <Label className="text-xs text-muted-foreground">{label}</Label>
          <p className="mt-1 text-[11px] text-muted-foreground">
            Titles appear in Google results and browser tabs. Descriptions show under the title and in link previews —
            aim for 150-160 characters.
          </p>
        </div>
        <button
          type="button"
          data-testid="field-page_seo-add"
          onClick={() => onChange([...arr, { page: "home", title: { en: "", ar: "" }, description: { en: "", ar: "" }, image: "" }])}
          className="btn-outline h-9 px-4 text-xs"
        >
          + Add page
        </button>
      </div>

      <div className="mt-4 space-y-3">
        {arr.map((item, i) => (
          <div
            key={i}
            data-testid={`page-seo-row-${i}`}
            className="grid gap-3 border border-border p-4"
            style={{ borderRadius: "var(--radius)" }}
          >
            <div className="flex items-center justify-between gap-3">
              <select
                className="h-9 rounded-md border border-input bg-background px-3 text-sm outline-none focus:ring-1 focus:ring-ring"
                value={item?.page || "home"}
                data-testid={`page-seo-page-${i}`}
                onChange={(e) => patch(i, { page: e.target.value })}
              >
                {PAGES.map((p) => (
                  <option key={p.value} value={p.value}>{p.label}</option>
                ))}
              </select>
              <button
                type="button"
                data-testid={`page-seo-remove-${i}`}
                onClick={() => onChange(arr.filter((_, x) => x !== i))}
                className="text-xs text-destructive hover:underline"
              >
                Remove
              </button>
            </div>

            <div className="grid grid-cols-2 gap-2">
              <Input
                value={item?.title?.en || ""}
                placeholder="Page title (English)"
                data-testid={`page-seo-title-en-${i}`}
                onChange={(e) => patch(i, { title: { ...(item?.title || {}), en: e.target.value } })}
              />
              <Input
                dir="rtl"
                value={item?.title?.ar || ""}
                placeholder="عنوان الصفحة"
                data-testid={`page-seo-title-ar-${i}`}
                onChange={(e) => patch(i, { title: { ...(item?.title || {}), ar: e.target.value } })}
              />
            </div>

            <div className="grid grid-cols-2 gap-2">
              <Textarea
                rows={3}
                value={item?.description?.en || ""}
                placeholder="Meta description (English)"
                data-testid={`page-seo-desc-en-${i}`}
                onChange={(e) => patch(i, { description: { ...(item?.description || {}), en: e.target.value } })}
              />
              <Textarea
                rows={3}
                dir="rtl"
                value={item?.description?.ar || ""}
                placeholder="وصف الصفحة"
                data-testid={`page-seo-desc-ar-${i}`}
                onChange={(e) => patch(i, { description: { ...(item?.description || {}), ar: e.target.value } })}
              />
            </div>

            <p className="text-[11px] text-muted-foreground">
              {(item?.description?.en || "").length} characters (English)
            </p>
            <AiToolbar
              fieldLabel={`SEO meta description — ${item?.page || "page"} page`}
              value={item?.description}
              onChange={(v) => patch(i, { description: v })}
              testKey={`page-seo-desc-${i}`}
              context={`Website page: ${item?.page || "home"}. Page title: ${item?.title?.en || ""}`}
              allowExpand={false}
              allowSeo
            />
          </div>
        ))}
      </div>
    </div>
  );
}
